import * as React from "react";
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Typography from "@mui/material/Typography";
import reservationStore from "../../store/reservationStore";
import { useEffect, useState } from "react";
import api from "../../utils/api";
import * as util from "../../utils/util";
import { d2024, d2025, d2026 } from "../../utils/holidays";
import { PickersDay } from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { Divider } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const hospitalParam = {
  cusId: '',
  famId: '',
  hosId: ''
}

const SetDate = (props: any) => {
  const storeData: any = reservationStore();
  const [allItems, setAllItems] = React.useState([]);
  const [capacity, setCapacity] = React.useState([{ classes: '', dateName: '', locdate: '', capacityClassItem: '', companyId: null, isCount: null, isOpen: null, }]);
  const [packagesInfo, setPackagesInfo] = React.useState([]);
  const [disabledDays, setDisabledDays] = useState({ item: [{ locdate: '' }] }); // 선택 불가 일자
  const [iStartDate, setIStartDate] = useState(new Date());
  const [iEndDate, setIEndDate] = useState(new Date());
  const [endDateForFirst, setEndDateForFirst] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [isSatOpen, setIsSatOpen] = React.useState(true);
  const [showCloseItems, setShowCloseItems] = React.useState(Boolean);
  const [isReady, setIsReady] = React.useState(false);

  // 초기 로딩 후에 컴포넌트 렌더링
  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 200); // 10ms 지연 후 렌더링 (최소한의 지연)
  }, []);

  useEffect(() => {
    // 필요한 api 호출을 위한 파라미터 세팅
    const companyInfo = JSON.parse((localStorage.getItem('companyInfo') || ''));
    hospitalParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.hosId = decodeURIComponent(storeData.reservationInfo.hosId);

    // 선택 병원의 capacity items
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/items/${new Date().getFullYear()}`).then(res => {
      setAllItems(res.data.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원의 capacity
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/capacities/${new Date().getFullYear()}`).then(res => {
      setCapacity(res.data.data.map((v: any) => {
        return {
          classes: v.classes,
          dateName: v.title,
          locdate: v.start.replaceAll(/[-]/ig, ""),
          capacityClassItem: v.capacityClassItem,
          companyId: v.companyId,
          isCount: v.isCount,
          isOpen: v.isOpen,
        };
      }))
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원과 접속 회원의 기업간의 제공되는 패키지
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/companies/${encodeURIComponent(companyInfo.company_id)}/packages`).then(res => {
      setPackagesInfo(res.data.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택한 병원 정보
    api.post('customer/api/v1/CU_003_003_2', hospitalParam).then(res => {
      localStorage.setItem('HOS_INFO', JSON.stringify(res.data));
      setIsSatOpen(res.data['satOpen']);
    }).catch(function (error) {
      console.log(error)
    });

    // 휴일, 시작일, 종료일 disalbed 처리
    setDisabledDays(getRestDay(new Date().getFullYear()));
    const twoW = new Date().setDate(new Date().getDate() + 14);

    const rStartDate = new Date(companyInfo.reservation_start);
    let rEndDate = new Date(companyInfo.reservation_end);

    // 에너지기술연구원 - 하드코딩
    if ( companyInfo.company_id === 'CO#21' && hospitalParam.hosId === 'HO#373'){
        rEndDate = new Date(2026, 9, 17);
    } 
    if ( companyInfo.company_id === 'CO#21' && hospitalParam.hosId === 'HO#375' ){
        rEndDate = new Date(2026, 9, 24);
    }
    
    const todayDate = new Date();

    if(rStartDate <= todayDate && todayDate <= rEndDate) { // 현재 날짜가 예약 기간에 포함되어 있으면 검진기간으로 설정
      setStartDate(util.getBiggerDate(twoW, companyInfo.inspection_start));
      
      //2025-05-29 하드코딩 // 2026.3.20 수정 // 2026.3.25 대전성모추가
      if ( companyInfo.company_id === 'CO#21' && hospitalParam.hosId === 'HO#373') {
        // 에너지기술연구원 - 충남대병원
        setEndDateForFirst(new Date(2026, 9, 31));
      } else if ( companyInfo.company_id === 'CO#21' && hospitalParam.hosId === 'HO#375') {
        // 에너지기술연구원 - 대전성모
        setEndDateForFirst(new Date(2026, 10, 7));
      } else if ( companyInfo.company_id === 'CO#21' && ['HO#117', 'HO#114'].includes(hospitalParam.hosId)) {
        // 에너지기술연구원 - 건양대
        setEndDateForFirst(new Date(2026, 10, 30));
      } else {
        setEndDateForFirst(new Date(companyInfo.inspection_end));
      }
    } else { // 예약 기간에 포함 안되면 예약 불가 (시작날짜 -> 검진 마지막날짜 +1)
      let iEndDate = new Date(companyInfo.inspection_end);
      iEndDate.setDate(iEndDate.getDate() + 1);
      setStartDate(iEndDate);
      setEndDateForFirst(new Date(companyInfo.inspection_end));
    }

    return () => {
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  }, []);

  // 휴일 목록 제공 (기존에 API 호출 및 휴일 데이터 불러 왔었는데, API 호출 안되어서 휴일 데이터 제공 / 2024, 2025)
  function getRestDay(year: any) {
    let restDay: any = [];
    if (year === 2024) restDay = d2024;
    if (year === 2025) restDay = d2025;
    if (year === 2026) restDay = d2026;
    return restDay;
  }

  // 병원, 일자, 검진 마감 구분
  function getClassesOrder(classes: any) {
    switch (classes) {
      case 'hospital-close': return 0;    // 휴무
      case 'day-close': return 1;         // 전체마감
      case 'inspection-close': return 2;  // 검진마감
      case 'company-day-close': return 3; // 기업 전체 마감
      case 'company-ip-close': return 4;  // 기업 검진항목 마감
      default: return 5;
    }
  }

  // 검진항목 마감 우선
  function getClassesOrder1(classes: any) {
    switch (classes) {
      case 'hospital-close': return 0;    // 휴무
      case 'inspection-close': return 1;  // 검진 마감
      case 'company-ip-close': return 2;  // 기업 검진항목 마감
      case 'day-close': return 3;         // 전체마감
      case 'company-day-close': return 4; // 기업 전체 마감
      default: return 5;
    }
  }

  // 기업 전체 마감 우선
  function getClassesOrder2(classes: any) {
    switch (classes) {
      case 'hospital-close': return 0;    // 휴무
      case 'company-day-close': return 1; // 기업 전체 마감
      case 'day-close': return 2;         // 전체마감
      case 'inspection-close': return 3;  // 검진 마감
      case 'company-ip-close': return 4;  // 기업 검진항목 마감
      default: return 5;
    }
  }

  // 선택된 일자의 마감 정보(capacity) 가져오기
  function selectedReservationDate(selecteDate: any) {
    const selectedDate = dayjs(selecteDate.$d).format('YYYY-MM-DD');
    storeData.setReservationInfo('date', selectedDate);
    let FAM_INFO = JSON.parse(localStorage.getItem("FAM_INFO") || '');

    let filtered: any = {};
    if(capacity.filter(c => c.locdate === selectedDate.replaceAll("-", "")).some(d => FAM_INFO.companyId == d.companyId && d.classes === 'company-ip-close')) { // 해당되는 기업이라면
      filtered = capacity.filter(c => c.locdate === selectedDate.replaceAll("-", "") && c.classes === 'company-ip-close');
    } else { // 해당되는 기업이 아니라면
      filtered = capacity.filter(c => c.locdate === selectedDate.replaceAll("-", ""));
    }

    const close = filtered.filter((c: any) => {
      if(c.capacityClassItem != null) { // capacityClassItem이 null이 아닌 경우에만 처리
        if (c.companyId == null) { // 기업마감이 아닌 경우
          return !c.isOpen // 선택된 날짜이면서 인원이 다 차있다면 일부마감 보여주기
        } else { // 기업마감인 경우
          if(filtered.some((d:any) => FAM_INFO.companyId == d.companyId)) { // 선택된 날짜에 해당되는 기업이라면
            return FAM_INFO.companyId == c.companyId && !c.isOpen // 해당 기업이면서 인원이 다 차있다면 일부마감 보여주기
          } else { // 해당 기업이 아니라면 아무 동작 x
            return ;
          }
        }
      }
    });

    // const close = capacity.filter((c: any) => (c.locdate === selectedDate.replaceAll("-", "")) && !c.isOpen); // 캐파 중에 선택된 날짜이면서 인원이 다 안찬 리스트 필터링
    // const close = capacity.filter((c: any) => {
    //   if (c.companyId == null) { // 기업마감이 없는 경우
    //     return c.locdate === selectedDate.replaceAll("-", "") && !c.isOpen // 선택된 날짜이면서 인원이 다 차있다면 일부마감 보여주기
    //   } else { // 기업마감이 있는 경우
    //     if(capacity.filter(c => c.locdate === selectedDate.replaceAll("-", "")).some(d => FAM_INFO.companyId == d.companyId)) { // 선택된 날짜에 해당되는 기업이 있다면
    //       return c.locdate === selectedDate.replaceAll("-", "") && FAM_INFO.companyId == c.companyId && !c.isOpen // 해당 기업이면서 인원이 다 차있다면 일부마감 보여주기
    //     } else { // 해당 기업이 없다면 일부마감 보여주기
    //       return c.locdate === selectedDate.replaceAll("-", "")
    //     }
    //     // return c.locdate === selectedDate.replaceAll("-", "") && FAM_INFO.companyId != c.companyId // 캐파중에서 선택된 날짜이면서 해당되는 기업이 아닌 리스트
    //   }
    // })
    storeData.setCloseItems([]);
    if (close.length > 0) {
      const dateNameArr: any = close.map((c: any) => c.capacityClassItem);
      storeData.setCloseItems(dateNameArr);
      setShowCloseItems(true);
    } else {
      setShowCloseItems(false);
    }
  }

  // 일부마감 일자 하이라이트
  const CustomDay = (props: any) => {
    let disabled = false;
    let targetDate = dayjs(props.day.$d).format('YYYYMMDD');
    let div = '';
    if (disabledDays.item.some(d => d.locdate == targetDate)) {
      disabled = !true;
    } else if(props.day.$W === 0){ // 일요일 예약일자 close
      disabled = false;
    } else if(props.day.$W === 6 && !isSatOpen) {  // !(토요일 && 병원 오픈) => 예약일자 close
      disabled = isSatOpen
    } else if (capacity.some(d => d.locdate == targetDate)) {
      let FAM_INFO = JSON.parse(localStorage.getItem("FAM_INFO") || '');
      let classes, dateName, isCount, isOpen;

      // '기업전체' 마감 인지 판단
      if(capacity.filter(d => d.locdate === targetDate).some(d => d.classes === 'company-day-close' && FAM_INFO.companyId == d.companyId)) { // '기업전체' 마감이면서 해당 기업이면 -> 기업전체를 우선으로
        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate && d.classes === 'company-day-close' && FAM_INFO.companyId == d.companyId)[0]);
      } else { // '기업전체' 마감 없음 -> 기존 우선순위 적용
        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate)
        .sort((a, b) => getClassesOrder(a.classes) - getClassesOrder(b.classes))[0]);
      }      

      // 전체에 대한 마감일 때 인원이 설정 되어 있다면 우선순위를 바꿈 (인원이 다 차면 isOpen이 false로 변경) (인원 설정 isOpen -> true, isCount -> true) (인원 다 차면 isOpen -> false, 인원 설정x isOpen -> null)
      if((classes === 'day-close' || classes === 'company-day-close') && isOpen === true) {
        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate)
      .sort((a, b) => getClassesOrder1(a.classes) - getClassesOrder1(b.classes))[0]);
      }

      if (classes === 'inspection-close') {

        // 해당되는 기업이고, 기업 마감인 경우 기업 마감으로 처리
        if(capacity.filter(d => d.locdate === targetDate && FAM_INFO.companyId == d.companyId).some(d => d.classes === 'company-ip-close')) {

          const items = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
          const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목

          const closePackage = packagesInfo.filter((pack: any) =>
            pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
              .some((clazz: any) => {
                const limit = clazz.choiceLimit;
                const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length;
                const originCount = clazz.piis.length;
                return originCount - closeCount === 0;
              }));
          const basicClosePackage = packagesInfo.filter((pack: any) =>
            pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
              .filter((clazz: any) => clazz.piis.some((pii: any) => {
                return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
              })).length !== 0
          );

          const capacityItems = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => v);
          if (capacityItems.some(d => FAM_INFO.companyId == d.companyId)) { // 기업 마감에 해당하는 기업이라면
            disabled = true;
            div = 'full'
            capacityItems.filter((item: any) => item.companyId == FAM_INFO.companyId && !item.isOpen).some((item: any) => { // 해당되는 기업이면서 마감인원이 다 찼을 경우 불가능
              const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
              disabled = open;
              if (open) { div = 'part' } else { div = 'full' }
            })
          } else { // 해당하지 않는 기업이라면 항상 오픈
            disabled = true;
            div = 'full'
          }
          
        } else { // 기업마감이 아닌 경우 -> 검진 마감으로 처리
          if (capacity.filter(v => v.classes === 'inspection-close' && v.locdate === targetDate).length === allItems.map((v: any) => v.items).flat().length) {
            disabled = !true;
            div = 'full';
            const capacityItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v);
            capacityItems.filter((item: any) => item.isCount && !item.isOpen).some((item: any) => { // 마감인원설정 중에서 인원이 다 찼을 경우
              disabled = !false;
              div = 'part';
            })
          } else {
            // const capacityClassItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v.capacityClassItem);
            // const groups = capacityClassItems.map((v: any) => v.group.uid);
            // const items = capacityClassItems.map((v: any) => v.item.code);
            const items = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
            const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목

            const closePackage = packagesInfo.filter((pack: any) =>
              pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
                .some((clazz: any) => {
                  const limit = clazz.choiceLimit;
                  const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length;
                  const originCount = clazz.piis.length;
                  return originCount - closeCount === 0;
                }));
            const basicClosePackage = packagesInfo.filter((pack: any) =>
              pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
                .filter((clazz: any) => clazz.piis.some((pii: any) => {
                  return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
                })).length !== 0
            );
  
            disabled = true;
            div = 'full'
            const capacityItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v);
            capacityItems.filter((item: any) => (item.isCount && !item.isOpen) || !item.isCount).some((item: any) => { // 마감인원이 설정안되거나 마감인원이 다 찼을 경우
              const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
              disabled = open;
              if (open) { div = 'part' } else { div = 'full' }
            })
  
            // const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < packagesInfo.length;
            // disabled = open;
            // if (open) { div = 'part' } else { div = 'full' }
          }
        }
      } else if (classes === 'company-day-close') { // 기업 전체 마감
        const capacityItems = capacity.filter((v: any) => v.classes === 'company-day-close' && v.locdate === targetDate).map((v: any) => v);

        disabled = true;
        capacityItems.filter((item: any) => item.companyId == FAM_INFO.companyId && !item.isOpen).some((item: any) => { // 해당되는 기업이면서 마감인원이 다 차면 사용가능
          disabled = false;
        })

      } else if (classes === 'company-ip-close') { // 기업 검진항목 마감
        // console.log(targetDate, '기업 검진항목 마감');

        // const capacityClassItems = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => v.capacityClassItem);
        // const items = capacityClassItems.map((v: any) => v.item.code);
        const items = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
        const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목

        const closePackage = packagesInfo.filter((pack: any) =>
          pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
            .some((clazz: any) => {
              const limit = clazz.choiceLimit;
              const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length;
              const originCount = clazz.piis.length;
              return originCount - closeCount === 0;
            }));
        const basicClosePackage = packagesInfo.filter((pack: any) =>
          pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
            .filter((clazz: any) => clazz.piis.some((pii: any) => {
              return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
            })).length !== 0
        );

        const capacityItems = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => v);
        if (capacityItems.some(d => FAM_INFO.companyId == d.companyId)) { // 기업 마감에 해당하는 기업이라면
          disabled = true;
          div = 'full'
          capacityItems.filter((item: any) => item.companyId == FAM_INFO.companyId && !item.isOpen).some((item: any) => { // 해당되는 기업이면서 마감인원이 다 찼을 경우 불가능
            const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
            disabled = open;
            if (open) { div = 'part' } else { div = 'full' }
          })
        } else { // 해당 되는 기업이 아니라면 항상 open
          disabled = true;
          div = 'full'
        }

      } else {
        if ((isCount && !isOpen) || !isCount) { // 마감 인원이 가득 차거나 마감 인원 설정이 안되어 있으면 disabled
          disabled = false;
        } else {
          disabled = true;
        }
        // disabled = false;
      }
    } else {  
      /* 
        아래 경우 제외 하고 예약일자 오픈
        1. 휴일
        2. 일요일
        3. 토요일 open 아닌 경우
        4. 토요일 open인데 캐파 있는 경우 (캐파 확인 후 결정)
      */
      if (props.day.$W !== 0) disabled = true;  // 예약일자 open
    }

    let matchedStyles = {};
    // 2주 마지막날 일부 마감처리
    let beforeStartDate = new Date(startDate);
    beforeStartDate.setDate(beforeStartDate.getDate() - 1);

    if ((dayjs(beforeStartDate) <= dayjs(props.day)) && (dayjs(endDateForFirst) >= dayjs(props.day))
      && disabled && div === 'part') { // 일부 마감 하이라이트 처리
      matchedStyles = { backgroundColor: '#e5efff !important', color: '#0e1fff' };
    };

    return <PickersDay {...props} sx={{ ...matchedStyles }} />;
  };



  return (
    <Container sx={{ p: 0 }}>

      <Stack direction='row' justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#0d670320', mt: 1, p: 1, borderRadius: 3 }} >
        {/* <ErrorOutlineOutlinedIcon sx={{ fontSize: '18px', color: '#777' }} /> */}
        <Typography component={'div'} sx={{ fontSize: '16px', m: 1 }}>
          검진일은 현재 날짜 기준, <b> &nbsp;2주 후&nbsp; </b> 부터 선택이 가능합니다.
        </Typography>
      </Stack>

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
        <DemoContainer components={['StaticDatePicker']}>
          <DemoItem>
            {isReady ? (
              <StaticDatePicker
                maxDate={dayjs(endDateForFirst)}
                shouldDisableDate={
                  (date: any) => {
                    let disabled = false;
                    let targetDate = dayjs(date.$d).format('YYYYMMDD');
                    if (dayjs(startDate).format('YYYYMMDD') > targetDate) { // [1] 현재 날짜 기준, 2주는 disabled
                      disabled = false;
                    } else if (disabledDays.item.some(d => d.locdate == targetDate)) { // [1] 휴일 날짜들 disabled
                      disabled = !true;
                    } else if(date.$W === 0){ // 일요일 예약일자 close
                      disabled = false;
                    } else if(date.$W === 6 && !isSatOpen) {  // !(토요일 && 병원 오픈) => 예약일자 close
                      disabled = isSatOpen
                    } else if (capacity.some(d => d.locdate == targetDate)) { // [1] 캐파 설정이 되어 있는 날짜들
                      let FAM_INFO = JSON.parse(localStorage.getItem("FAM_INFO") || '');
                      // const { classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate)
                      //   .sort((a, b) => getClassesOrder(a.classes) - getClassesOrder(b.classes))[0]; // 휴무 > 전체마감 > 검진항목마감 -> 1, 2, 3순위, 순위가 젤 높은걸로 반영
  
                      let classes, dateName, isCount, isOpen;

                      // '기업전체' 마감 인지 판단
                      if(capacity.filter(d => d.locdate === targetDate).some(d => d.classes === 'company-day-close' && FAM_INFO.companyId == d.companyId)) { // '기업전체' 마감이면서 해당 기업이면 -> 기업전체를 우선으로
                        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate && d.classes === 'company-day-close' && FAM_INFO.companyId == d.companyId)[0]);
                      } else { // '기업전체' 마감 없음 -> 기존 우선순위 적용
                        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate)
                        .sort((a, b) => getClassesOrder(a.classes) - getClassesOrder(b.classes))[0]);
                      }      
                
                      // 전체에 대한 마감일 때 인원이 설정 되어 있다면 우선순위를 바꿈 (인원이 다 차면 isOpen이 false로 변경) (인원 설정 isOpen -> true, isCount -> true) (인원 다 차면 isOpen -> false, 인원 설정x isOpen -> null)
                      if((classes === 'day-close' || classes === 'company-day-close') && isOpen === true) {
                        ({ classes, dateName, isCount, isOpen } = capacity.filter(d => d.locdate === targetDate)
                      .sort((a, b) => getClassesOrder1(a.classes) - getClassesOrder1(b.classes))[0]);
                      }
  
                      // console.log(isCount, 'isCount');
                      // console.log(isOpen, 'isOpen');
  
                      if (classes === 'inspection-close') { // [2] 검진항목 마감

                        // 해당되는 기업이고, 기업 마감인 경우 기업 마감으로 처리
                        if(capacity.filter(d => d.locdate === targetDate && FAM_INFO.companyId == d.companyId).some(d => d.classes === 'company-ip-close')) {
                          const items = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
                          const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목
                          
                          // 패키지 ipClass '기본' 이 아닌 것들 중에 
                          const closePackage = packagesInfo.filter((pack: any) =>
                            pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
                              .some((clazz: any) => {
                                const limit = clazz.choiceLimit; // 최대 설정 갯수
                                const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length; // 마감항목코드와 일치하는 검진항목 갯수
                                const originCount = clazz.piis.length; // 검진항목 갯수
                                return originCount - closeCount === 0;
                              }));
    
                          // 패키지 ipClass '기본' 중에 마감 항목 코드와 일치하는 패키지들
                          const basicClosePackage = packagesInfo.filter((pack: any) =>
                            pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
                              .filter((clazz: any) => clazz.piis.some((pii: any) => {
                                return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
                              })).length !== 0
                          );
    
                          const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
                          disabled = open;

                        } else { // 기업마감이 아닌 경우 -> 검진 마감으로 처리
                          if (capacity.filter(v => v.classes === 'inspection-close' && v.locdate === targetDate).length === allItems.map((v: any) => v.items).flat().length) { // [3] 검진항목 마감 길이와 모든 검진항목 길이가 일치하면 -> 해당 날짜 마감
                            const capacityItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v);
                            disabled = true;
                            capacityItems.filter((item: any) => !item.isCount).some((item: any) => { // 마감인원설정이 안된 아이템
                              // console.log(item);
                              disabled = false;
                            })
                          } else { // [3] 길이가 다르면 -> 해당 날짜 일부 검진항목 마감 표시
                            // const capacityClassItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v.capacityClassItem);
                            // const groups = capacityClassItems.map((v: any) => v.group.uid);
                            // const items = capacityClassItems.map((v: any) => v.item.code);
                            const items = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
                            const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목

                            // 패키지 ipClass '기본' 이 아닌 것들 중에 
                            const closePackage = packagesInfo.filter((pack: any) =>
                              pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
                                .some((clazz: any) => {
                                  const limit = clazz.choiceLimit; // 최대 설정 갯수
                                  const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length; // 마감항목코드와 일치하는 검진항목 갯수
                                  const originCount = clazz.piis.length; // 검진항목 갯수
                                  return originCount - closeCount === 0;
                                }));
    
                            // 패키지 ipClass '기본' 중에 마감 항목 코드와 일치하는 패키지들
                            const basicClosePackage = packagesInfo.filter((pack: any) =>
                              pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
                                .filter((clazz: any) => clazz.piis.some((pii: any) => {
                                  return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
                                })).length !== 0
                            );
    
                            const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
                            disabled = open;
    
                            // const capacityItems = capacity.filter((v: any) => v.classes === 'inspection-close' && v.locdate === targetDate).map((v: any) => v);
                            // 마감인원이 설정 되거나 마감 인원이 다 안찼을 때 disabled = true
                            // capacityItems.filter((item: any) => (item.isCount && item.isOpen)).some((item: any) => {
                            //   disabled = true;
                            // })
                          }
                        }
                      } else if (classes === 'company-day-close') { // 기업 전체 마감
                        const capacityItems = capacity.filter((v: any) => v.classes === 'company-day-close' && v.locdate === targetDate).map((v: any) => v);
                        disabled = true;
                        capacityItems.filter((item: any) => item.companyId == FAM_INFO.companyId && !item.isOpen).some((item: any) => { // 해당되는 기업이면서 마감인원이 다 차면 사용 가능
                          disabled = false;
                        })
  
                      } else if (classes === 'company-ip-close') { // 기업 검진항목 마감
                        // console.log(targetDate, '기업 검진항목 마감');
  
                        // const capacityClassItems = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => v.capacityClassItem);
                        // const items = capacityClassItems.map((v: any) => v.item.code);
                        const items = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => ({code: v.capacityClassItem.item.code, isOpen: v.isOpen}));
                        const basicOrClosePackage = Object.values(packagesInfo).map((v: any) => v.ipClassInfos).flat().map((v: any) => v.piis).flat(); // 패키지 안에 모든 항목
                        
                        // 패키지 ipClass '기본' 이 아닌 것들 중에 
                        const closePackage = packagesInfo.filter((pack: any) =>
                          pack.ipClassInfos.filter((clazz: any) => clazz.ipClass !== '기본')
                            .some((clazz: any) => {
                              const limit = clazz.choiceLimit; // 최대 설정 갯수
                              const closeCount = clazz.piis.filter((pii: any) => items.some(item => item.code === pii.ipCode && item.isOpen === false)).length; // 마감항목코드와 일치하는 검진항목 갯수
                              const originCount = clazz.piis.length; // 검진항목 갯수
                              return originCount - closeCount === 0;
                            }));
  
                        // 패키지 ipClass '기본' 중에 마감 항목 코드와 일치하는 패키지들
                        const basicClosePackage = packagesInfo.filter((pack: any) =>
                          pack.ipClassInfos.filter((clazz: any) => clazz.ipClass === '기본')
                            .filter((clazz: any) => clazz.piis.some((pii: any) => {
                              return items.some((item: any) => item.code === pii.ipCode && item.isOpen === false)
                            })).length !== 0
                        );
  
                        const open = Array.from(new Set(basicClosePackage.map((p: any) => p.id).concat(closePackage.map((p: any) => p.id)))).length < basicOrClosePackage.length;
                        disabled = open;
  
                        // const capacityItems = capacity.filter((v: any) => v.classes === 'company-ip-close' && v.locdate === targetDate).map((v: any) => v);
                        // 마감인원이 설정 되거나 마감 인원이 다 안찼을 때 disabled = true
                        // 항목마감은 완전 마감이 아니라 disabled 가 true
                        // capacityItems.filter((item: any) => (item.isCount && !item.isOpen)).some((item: any) => {
                        //   disabled = true;
                        // })
  
                      } else { // [2] 전체마감
                        if ((isCount && !isOpen) || !isCount) {
                          disabled = false; // 마감 인원이 가득 차거나 마감 인원 설정이 안되어 있으면 disabled
                        } else {
                          disabled = true; // 그 외에는 사용 가능
                        }
                        // disabled = false;
                      }
                    } else {  
                      /* 
                        아래 경우 제외 하고 예약일자 오픈
                        1. 휴일
                        2. 일요일
                        3. 토요일 open 아닌 경우
                        4. 토요일 open인데 캐파 있는 경우 (캐파 확인 후 결정)
                      */
                      if (date.$W !== 0) disabled = true;  // 예약일자 open
                    }
                    return !disabled;
                  }
                }
                onChange={(newValue) => selectedReservationDate(newValue)}
                sx={{
                  width: '100%', borderRadius: '12px 12px 0px 0px',
                  '& .MuiDateCalendar-root': { p: 2 },
                  '.MuiPickersToolbar-content': {
                    backgroundColor: '#f1f1f1',
                    p: '10px 0',
                    justifyContent: 'center', borderRadius: 3
                  },
                  '.MuiPickersToolbar-content .MuiDatePickerToolbar-title': {
                    fontSize: 18,
                    color: '#333',
                    fontWeight: 700
                  },
                  '.MuiPickersToolbar-content .MuiDatePickerToolbar-title:before': {
                    content: '"예약일은 "',
                    fontWeight: 500
                  },
                  '.MuiPickersToolbar-content .MuiDatePickerToolbar-title:after': {
                    content: '" 입니다 "',
                    fontWeight: 500
                  },
                  '.MuiTypography-overline': {
                    display: 'none'
                  },
                  '.MuiDialogActions-root ': {
                    display: 'none'
                  },
                  '.MuiDayCalendar-weekDayLabel': {
                    width: '40px',
                    height: '40px',
                    fontSize: 16
                  },
                  '.MuiPickersDay-root': {
                    width: '40px',
                    height: '40px',
                    fontSize: 16,
                    bgcolor: '#00bc1417',
                    fontWeight: 700
                  },
                  '.MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
                    bgcolor: '#ffa0a014',
                  }
                }}
                slots={{
                  day: CustomDay,
                }}
                slotProps={{
                  toolbar: {
                    toolbarFormat: 'MM월 DD일',
                  },
                  calendarHeader: { format: 'YYYY년 MM월' }
                }}
              />
            ) : (
              <Box sx={{ display: !isReady ? 'flex' : 'none', justifyContent: 'center', alignContent: 'center', p: 1 }}>
                <CircularProgress color="secondary" />
              </Box>
            )}
          </DemoItem>
        </DemoContainer>

        <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} sx={{ bgcolor: '#fff', borderTop: '1px solid #eee', p: 2 }}>
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#ff9d9d6e', mr: 1 }}></Box>
            <Typography sx={{ fontSize: 16 }}>예약마감</Typography>
          </Stack>
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#c3e0f8', mr: 1 }}></Box>
            <Typography sx={{ fontSize: 16 }}>일부마감</Typography>
          </Stack>
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
            <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#00bc143d', mr: 1 }}></Box>
            <Typography sx={{ fontSize: 16 }}>예약가능</Typography>
          </Stack>
        </Stack>

      </LocalizationProvider>

      <Box sx={{ bgcolor: '#FFFBF8', pb: 1, display: showCloseItems ? 'block' : 'none', flexDirection: 'column' }} >
        <Box sx={{ width: '100%' }}>
          <Typography sx={{ display: 'flex', fontSize: '16', m: 0, alignItems: 'center', justifyContent: 'center', bgcolor: '#ff6161', color: '#fff', fontWeight: 700, p: 1 }}>
            <ErrorRoundedIcon sx={{ mr: 1, color: '#fff' }} /> 일부 마감 항목

          </Typography>
        </Box>
        <Box sx={{ width: '100%' }}>
          {storeData.closeItems.map((ci: any, index: any) => (
            <Typography key={ci.uid} sx={{ display: 'flex', fontSize: '14px', m: 1, alignItems: 'center', justifyContent: 'center', }}>
              <ErrorOutlineOutlinedIcon sx={{ mr: 1, color: '#ff6161' }} />  {ci.item.name}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
}

export default SetDate;